import { render } from "./VueNumberSpinner.vue?vue&type=template&id=7feeb718"
import script from "./VueNumberSpinner.vue?vue&type=script&lang=js"
export * from "./VueNumberSpinner.vue?vue&type=script&lang=js"

import exportComponent from "/builds/Spartans/alpbachtal-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__